import * as React from 'react';
import SwipeableViews from 'react-swipeable-views';
import { ArrowBack, ArrowHidden, ArrowNext } from '../components/styled/Arrow';
import { isMobile } from '../helpers/util';
import { colors } from '../globalStyles';
import { FlexRow, SwipeRow } from './styled/Flex';

interface Props {
  children: React.ReactNode[];
  onChangeIndex: (index: number) => any;
  index: number;
  onNextArrowClick: () => any;
  onBackArrowClick: () => any;
}

const styles = {
  slideContainer: {
    padding: '30',
  },
  slide: {
    padding: 30,
    minHeight: 100,
    color: colors.white,
  },
};

export const AdaptiveSwipe = (props: Props) => (
  <>
    {
      isMobile() ? (
        <SwipeableViews slideStyle={styles.slideContainer} index={props.index} onChangeIndex={props.onChangeIndex}>
          {
            React.Children.map(props.children.filter((child: any) => child.props.hidden === false), (node, idx) => (
              <SwipeRow>
                { idx !== 0 ? <ArrowBack onClick={props.onBackArrowClick} /> : <ArrowHidden /> }
                { node }
                {
                  idx !== props.children.filter((child: any) => child.props.hidden === false).length - 1 ?
                    <ArrowNext onClick={props.onNextArrowClick} /> : <ArrowHidden />
                }
              </SwipeRow>
            ))
          }
        </SwipeableViews>
      ) : <FlexRow>{ props.children }</FlexRow>
    }
  </>
);
